function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0b0b61;}.cls-2{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_43",
  "data-name": "Rectangle 43",
  className: "cls-1",
  d: "M40,0h0A40,40,0,0,1,80,40h0A40,40,0,0,1,40,80h0A40,40,0,0,1,0,40H0A40,40,0,0,1,40,0Z",
  transform: "translate(0 0)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M52.84,20h-4a.61.61,0,0,0-.68.52.6.6,0,0,0,.52.67h4.16a6,6,0,0,1,6,6V52.84a6,6,0,0,1-6,6H27.16a6,6,0,0,1-6-6V27.16a6,6,0,0,1,6-6H46.5a.6.6,0,0,0,.51-.67A.58.58,0,0,0,46.5,20H27.16A7.16,7.16,0,0,0,20,27.15h0V52.84A7.17,7.17,0,0,0,27.16,60H52.84A7.18,7.18,0,0,0,60,52.84V27.16A7.17,7.17,0,0,0,52.84,20Z",
  transform: "translate(0 0)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M40.16,36.75a5.24,5.24,0,1,0-5.24-5.24,5.25,5.25,0,0,0,5.24,5.24Zm0-9.29h0a4.05,4.05,0,1,1-4,4.1v0A4,4,0,0,1,40.16,27.46Z",
  transform: "translate(0 0)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M45.7,48.82h0a.51.51,0,0,1-.51-.51V39.78a1.7,1.7,0,0,0-1.7-1.7H37.11a.6.6,0,0,0-.52.67.6.6,0,0,0,.52.52h6.38a.51.51,0,0,1,.51.51v8.53A1.7,1.7,0,0,0,45.7,50h.69a.51.51,0,0,1,.51.51V52a.51.51,0,0,1-.51.51H33.93a.51.51,0,0,1-.51-.51V50.52a.51.51,0,0,1,.51-.51h.68a1.71,1.71,0,0,0,1.71-1.7V43.5a1.71,1.71,0,0,0-1.71-1.7h-1a.5.5,0,0,1-.5-.5h0V39.78a.49.49,0,0,1,.49-.51h1.13a.6.6,0,0,0,.59-.59.59.59,0,0,0-.59-.59H33.62a1.69,1.69,0,0,0-1.7,1.69V41.3a1.7,1.7,0,0,0,1.7,1.7h1a.5.5,0,0,1,.5.5h0v4.81a.52.52,0,0,1-.49.51h-.7a1.7,1.7,0,0,0-1.7,1.7h0V52a1.7,1.7,0,0,0,1.7,1.7H46.38a1.7,1.7,0,0,0,1.7-1.7h0V50.52a1.7,1.7,0,0,0-1.7-1.7H45.7Z",
  transform: "translate(0 0)"
});

function SvgIconAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "28.22mm",
    height: "28.22mm",
    viewBox: "0 0 79.99 79.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_about") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAbout);
export default __webpack_public_path__ + "static/media/icon_about.f95d3a44.svg";
export { ForwardRef as ReactComponent };